module.exports = __webpack_public_path__ + "media/directory/message_icon-00878c4c.svg";